(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["siamaya-bar-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('siamaya-bar-gallery')) {
    customElements.define('siamaya-bar-gallery', class extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.initialized = true;
          this.opener = this.querySelector('[data-gallery-open]');
          this.image = this.querySelector('.siamaya-bar-gallery__image');
          this.dialog = this.querySelector('dialog');
          this.enlarged = this.querySelector('[data-gallery-enlarged]');
          this.status = this.querySelector('[data-gallery-status]');
          this.choices = [...this.querySelectorAll('[data-gallery-choice]')];
          this.choices.forEach((choice, index) => {
            choice.addEventListener('click', event => {
              event.preventDefault();
              this.selectImage(choice);
            });
            choice.addEventListener('keydown', event => {
              let target;
              if (event.key === 'ArrowRight') target = (index + 1) % this.choices.length;
              if (event.key === 'ArrowLeft') target = (index + this.choices.length - 1) % this.choices.length;
              if (event.key === 'Home') target = 0;
              if (event.key === 'End') target = this.choices.length - 1;
              if (event.key === ' ') target = index;
              if (target === undefined) return;
              event.preventDefault();
              this.choices[target].focus();
              this.selectImage(this.choices[target]);
            });
          });
          this.opener.addEventListener('click', event => {
            if (typeof this.dialog.showModal !== 'function') return;
            event.preventDefault();
            this.enlarged.src = this.opener.href;
            this.enlarged.alt = this.image.alt;
            this.enlarged.width = this.image.width;
            this.enlarged.height = this.image.height;
            this.dialog.showModal();
          });
          this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('close', () => this.opener.focus());
          this.dialog.addEventListener('click', event => {
            const rect = this.dialog.getBoundingClientRect();
            if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
          });
        }
        if (typeof subscribe === 'function' && !this.variantUnsubscriber) {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data.sectionId) !== this.dataset.section) return;
            const mediaId = data.variant?.featured_media?.id;
            const choice = this.choices.find(item => item.dataset.mediaId === String(mediaId));
            if (choice) this.selectImage(choice);
          });
        }
      }
      disconnectedCallback() {
        this.variantUnsubscriber?.();
        this.variantUnsubscriber = undefined;
      }
      selectImage(choice) {
        this.image.srcset = choice.dataset.mainSrcset;
        this.image.src = choice.dataset.mainSrc;
        this.image.alt = choice.dataset.imageAlt;
        this.image.width = Number(choice.dataset.imageWidth);
        this.image.height = Number(choice.dataset.imageHeight);
        this.opener.href = choice.href;
        this.opener.setAttribute('aria-label', choice.dataset.openLabel);
        this.choices.forEach(item => item.removeAttribute('aria-current'));
        choice.setAttribute('aria-current', 'true');
        this.status.textContent = choice.getAttribute('aria-label');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["siamaya-flavor-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('siamaya-flavor-gallery')) {
    customElements.define('siamaya-flavor-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.opener = this.querySelector('[data-gallery-open]');
        this.image = this.querySelector('.siamaya-flavor-gallery__image');
        this.dialog = this.querySelector('dialog');
        this.enlarged = this.querySelector('[data-gallery-enlarged]');
        this.choices = [...this.querySelectorAll('[data-gallery-choice]')];
        this.choices.forEach((choice, index) => {
          choice.addEventListener('click', event => {
            event.preventDefault();
            this.selectImage(choice);
          });
          choice.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % this.choices.length;
            if (event.key === 'ArrowLeft') target = (index + this.choices.length - 1) % this.choices.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.choices.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            this.choices[target].focus();
            this.selectImage(this.choices[target]);
          });
        });
        this.opener.addEventListener('click', event => {
          if (typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          this.enlarged.src = this.opener.href;
          this.enlarged.alt = this.image.alt;
          this.dialog.showModal();
        });
        this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.opener.focus());
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        });
      }
      selectImage(choice) {
        this.image.srcset = choice.dataset.mainSrcset;
        this.image.src = choice.dataset.mainSrc;
        this.image.alt = choice.dataset.imageAlt;
        this.image.width = Number(choice.dataset.imageWidth);
        this.image.height = Number(choice.dataset.imageHeight);
        this.opener.href = choice.href;
        this.opener.setAttribute('aria-label', choice.dataset.openLabel);
        this.choices.forEach(item => item.removeAttribute('aria-current'));
        choice.setAttribute('aria-current', 'true');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
